import { render, staticRenderFns } from "./_HealthAssessment.vue?vue&type=template&id=7d035dd2&"
import script from "./_HealthAssessment.vue?vue&type=script&lang=js&"
export * from "./_HealthAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports